import { graphql } from "gql";

const INTERNAL_ADMIN_CREATE_TAG_MUTATION = graphql(`
  mutation InternalAdminCreateTag(
    $organizationId: ID!
    $input: AdminCreateTagInput!
  ) {
    internalAdminCreateTag(organizationId: $organizationId, input: $input) {
      ...InternalAdminTag
    }
  }
`);

export default INTERNAL_ADMIN_CREATE_TAG_MUTATION;
